import { render, staticRenderFns } from "./EditProductInStock.vue?vue&type=template&id=25308d70"
import script from "./EditProductInStock.vue?vue&type=script&lang=js"
export * from "./EditProductInStock.vue?vue&type=script&lang=js"
import style0 from "./EditProductInStock.vue?vue&type=style&index=0&id=25308d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports